// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1jmfM","range":"MonthRangeSwitch_range__1asQi","disabled":"MonthRangeSwitch_disabled__2BVXI"};